import proj4 from 'proj4';
import inside from '@turf/inside';
import { EPSG3067 } from '../config';

let provinces;

fetch('maakuntarajat.json')
  .then(response => response.json())
  .then((json) => { provinces = json.features; });

export default function getProvinces() {
  return provinces;
}

export function getEventProvince(event) {
  const eventCoord = proj4(EPSG3067, [parseFloat(event.LAT), parseFloat(event.LON)]);
  const point = { type: 'Feature', geometry: { type: 'Point', coordinates: eventCoord } };
  const eventProvince = Object.values(provinces).find(province => inside(point, province));

  return eventProvince ? eventProvince.properties.nimi : 'Kansainvälinen';
}



// WEBPACK FOOTER //
// ./src/services/provinces.js